import script from "./BasesDeConnaissance.vue?vue&type=script&setup=true&lang=js"
export * from "./BasesDeConnaissance.vue?vue&type=script&setup=true&lang=js"

import "./BasesDeConnaissance.vue?vue&type=style&index=0&id=48144457&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48144457"]])

export default __exports__